<template>
  <div>
    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
    <template v-if="!loading">
      <template v-if="localInvoices.length">
        <InvoicesTableList
          :invoices="localInvoices"
          :paginator="paginator"
        />
        <div class="text-right">
          <paginate v-if="paginator"
                    v-model="paginator.current_page"
                    :page-count="paginator.last_page"
                    :page-range="8"
                    :margin-pages="2"
                    :click-handler="getInvoices"
                    :prev-text="'&laquo'"
                    :next-text="'&raquo'"
                    :container-class="'pagination'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :active-class="'active green_btn'">
          </paginate>
        </div>
      </template>
      <template v-else>
        <h5 class="text-center">Накладные не найдены</h5>
      </template>
    </template>
  </div>
</template>

<script>

import api from "@/api";
import InvoicesTableList from "@/views/admin/invoices/components/InvoicesTableList.vue";
import Paginate from 'vuejs-paginate'

export default {
  props: ['invoices', 'drug'],
  components: {
    InvoicesTableList,
    Paginate,
  },
  data() {
    return {
      loading: false,
      paginator: null,
      localInvoices: [],
    }
  },
  mounted() {
    if (this.drug?.id) {
      this.getInvoices();
    }
  },
  methods: {
    async getInvoices(page = 1) {
      this.loading = true;
      let {data: r_data} = await api.post('/invoices/searchByData', {
        filter: {
          extra_type: 2, // adjust store invoices
          drug_id: this.drug?.id,
        },
        page
      })
      if (r_data.success) {
        const {data, ...pagination} = r_data.records
        this.paginator = pagination;
        this.localInvoices = data;
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading = false;
    }
  }
}

</script>
